import { ComponentProps, useEffect, useState } from "react";
import classnames from "classnames";

type Props = ComponentProps<"svg"> & {
  show: boolean;
  parentClassName?: string;
  onDebouncedChange?: (on: boolean) => void;
};

export default function Spinner({
  show: on,
  className,
  parentClassName,
  onDebouncedChange,
  ...rest
}: Props) {
  const [show, setShow] = useState(on);

  useEffect(() => {
    const handler = setTimeout(() => {
      setShow(on);
      onDebouncedChange?.(on);
    }, 200);
    return () => clearTimeout(handler);
  }, [on, onDebouncedChange]);

  if (!show) {
    return null;
  }

  return (
    <div className={parentClassName}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={classnames("fill-current", className)}
        {...rest}
      >
        <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z">
          <animateTransform
            attributeName="transform"
            dur="0.75s"
            repeatCount="indefinite"
            type="rotate"
            values="0 12 12;360 12 12"
          />
        </path>
      </svg>
    </div>
  );
}
